var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"col-12 text-center alert alert-info notification_box",staticStyle:{"margin-top":"15%"}},[_vm._v(" "+_vm._s(_vm.$t('add_infos'))+".     "),_c('a',{staticClass:"ml-2",attrs:{"href":"#"},on:{"click":_vm.goToParams}},[_vm._v(_vm._s(_vm.$t('go_to_params')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }